import {
  HomeRounded as HomeIcon,
  DomainRounded as AdminIcon,
  PeopleRounded as UsersIcon,
  PersonRounded as UserIcon,
  DoneAllRounded as ActionsIcon,
  AccountTreeRounded as OrgChartIcon,
  BeachAccessRounded as LeaveIcon,
  MoneyRounded as ExpensesIcon,
  AssessmentRounded as LeaveBalancesIcon
} from '@material-ui/icons';

import { PageDescriptor } from 'framework';
import * as screens from 'screens';

export const pages: Record<string, PageDescriptor> = {
  home: {
    title: 'landing',
    path: '/',
    icon: HomeIcon,
    screen: screens.Home,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  pricing: {
    title: 'pricingPageTitle',
    path: '/pricing',
    icon: HomeIcon,
    screen: screens.PricingPage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  signup: {
    title: 'pricingPageTitle',
    path: '/signup',
    icon: HomeIcon,
    screen: screens.PricingPage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  features: {
    title: 'featuresPageTitle',
    path: '/features',
    icon: HomeIcon,
    screen: screens.FeaturesPage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  leaveManagementFeature: {
    title: 'featurePageLeaveTitle',
    path: '/features/leave-management',
    icon: HomeIcon,
    screen: screens.LeaveManagementFeaturePage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  expenseClaimsFeature: {
    title: 'featurePageExpensesTitle',
    path: '/features/expense-claims',
    icon: HomeIcon,
    screen: screens.ExpenseClaimsFeaturePage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  onboardingFeature: {
    title: 'featurePageOnboardingTitle',
    path: '/features/onboarding',
    icon: HomeIcon,
    screen: screens.OnboardingFeaturePage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  comparePersonio: {
    title: 'comparisonPagePersonioTitle',
    path: '/compare/personio',
    icon: HomeIcon,
    screen: screens.ComparePersonioPage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  compareBambooHr: {
    title: 'comparisonPageBambooHrTitle',
    path: '/compare/bamboohr',
    icon: HomeIcon,
    screen: screens.CompareBambooHrPage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  compareSpreadsheets: {
    title: 'comparisonPageSpreadsheetsTitle',
    path: '/compare/spreadsheets',
    icon: HomeIcon,
    screen: screens.CompareSpreadsheetsPage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  startupHrSoftware: {
    title: 'useCasePageStartupTitle',
    path: '/startup-hr-software',
    icon: HomeIcon,
    screen: screens.StartupHrSoftwarePage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  leaveManagementForSmallTeams: {
    title: 'useCasePageLeaveTitle',
    path: '/leave-management-for-small-teams',
    icon: HomeIcon,
    screen: screens.LeaveManagementForSmallTeamsPage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  expenseClaimsForStartups: {
    title: 'useCasePageExpenseTitle',
    path: '/expense-claims-for-startups',
    icon: HomeIcon,
    screen: screens.ExpenseClaimsForStartupsPage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  employeeOnboardingSoftware: {
    title: 'useCasePageOnboardingTitle',
    path: '/employee-onboarding-software',
    icon: HomeIcon,
    screen: screens.EmployeeOnboardingSoftwarePage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  mcpSetup: {
    title: 'mcpSetupPageTitle',
    path: '/mcp-setup',
    icon: HomeIcon,
    screen: screens.McpSetupPage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  privacy: {
    title: 'agreeToTos4',
    path: '/privacy',
    icon: HomeIcon,
    screen: screens.PrivacyPolicyPage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  terms: {
    title: 'agreeToTos2',
    path: '/terms',
    icon: HomeIcon,
    screen: screens.TermsOfServicePage,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  checkout: {
    title: 'checkout',
    path: '/checkout/:product',
    icon: HomeIcon,
    screen: screens.Checkout,
    hidden: true,
    authorized: false,
    ignoreContainer: true,
    groups: [],
    noHeader: true
  },
  callback: {
    title: 'loggingIn',
    path: '/callback',
    pathParams: [':organization'],
    icon: HomeIcon,
    screen: screens.Callback,
    authorized: false,
    hidden: true,
    noHeader: true
  },
  notFound: {
    title: 'pageNotFound',
    path: '/not-found',
    icon: HomeIcon,
    screen: screens.NotFound,
    authorized: false,
    hidden: true,
    noHeader: true
  },
  paymentSuccess: {
    title: 'paymentSuccess',
    path: '/payment/success',
    icon: HomeIcon,
    screen: screens.Home,
    hidden: true,
    authorized: false,
    groups: [],
    noHeader: true
  },
  paymentFailed: {
    title: 'paymentFailed',
    path: '/payment/failed',
    icon: HomeIcon,
    screen: screens.Home,
    hidden: true,
    authorized: false,
    groups: [],
    noHeader: true
  },
  signin: {
    title: 'signin',
    path: '/signin',
    icon: HomeIcon,
    screen: screens.Signin,
    hidden: true,
    authorized: false,
    groups: [],
    noHeader: true
  },
  // Generic (marketplace) consent — must precede `dashboard` (/:organization)
  // so the exact /mcp-consent path wins over the org wildcard.
  mcpConsentGeneric: {
    title: 'mcpConsentTitle',
    path: '/mcp-consent',
    icon: HomeIcon,
    screen: screens.McpConsentGeneric,
    hidden: true,
    authorized: false,
    groups: [],
    noHeader: true
  },
  mcpConsent: {
    title: 'mcpConsentTitle',
    path: '/:organization/mcp-consent',
    icon: HomeIcon,
    screen: screens.McpConsent,
    hidden: true,
    // The screen manages auth itself so it can persist the pending OAuth
    // request across login and restore it afterwards.
    authorized: false,
    groups: [],
    noHeader: true
  },
  dashboard: {
    title: 'dashboard',
    path: '/:organization',
    icon: HomeIcon,
    screen: screens.Dashboard,
    hidden: true,
    authorized: true,
    groups: []
  },
  actions: {
    title: 'actions',
    path: '/:organization/actions',
    icon: ActionsIcon,
    screen: screens.Actions,
    authorized: true,
    groups: []
  },
  leave: {
    title: 'leave',
    path: '/:organization/leave',
    icon: LeaveIcon,
    screen: screens.Leave,
    authorized: true,
    groups: []
  },
  expenses: {
    title: 'expenses',
    path: '/:organization/expenses',
    icon: ExpensesIcon,
    screen: screens.ExpensesPage,
    authorized: true,
    groups: []
  },
  expenseClaimDetail: {
    title: 'expenseClaimDetail',
    path: '/:organization/expenses/:expenseClaimId',
    icon: ExpensesIcon,
    screen: screens.ExpenseClaimDetailScreen,
    hidden: true,
    authorized: true,
    groups: []
  },
  orgChart: {
    title: 'orgChart',
    path: '/:organization/users/org-chart',
    icon: OrgChartIcon,
    screen: screens.OrgChart,
    hidden: true,
    authorized: true,
    groups: ['administrators', 'managers']
  },
  leaveBalances: {
    title: 'leaveBalances',
    path: '/:organization/users/leave-balances',
    icon: LeaveBalancesIcon,
    screen: screens.LeaveBalancesReport,
    hidden: true,
    authorized: true,
    groups: ['administrators', 'managers']
  },
  leaveAnalytics: {
    title: 'leaveAnalytics',
    path: '/:organization/users/leave-analytics',
    icon: LeaveBalancesIcon,
    screen: screens.LeaveAnalytics,
    hidden: true,
    authorized: true,
    groups: ['administrators']
  },
  user: {
    title: 'profile',
    path: '/:organization/user/:tab?',
    icon: UserIcon,
    screen: screens.User,
    authorized: true
  },
  users: {
    title: 'users',
    path: '/:organization/users/:userId?/:tab?',
    icon: UsersIcon,
    screen: screens.Users,
    authorized: true,
    groups: ['administrators', 'managers']
  },
  admin: {
    title: 'administration',
    path: '/:organization/admin/:tab?',
    icon: AdminIcon,
    screen: screens.OrgAdmin,
    authorized: true,
    groups: ['administrators']
  }
};
